var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.56608 6.70758C7.55909 6.80418 7.55554 6.90173 7.55554 7.00012V8.73388C6.66489 8.93599 6 9.7325 6 10.6843V17.0001C6 18.1047 6.89543 19.0001 8 19.0001H12.4444C13.4416 19.0001 14.2682 18.2704 14.4197 17.3159H16C16.1466 17.3159 16.2914 17.308 16.4339 17.2926C16.2841 19.3652 14.5552 21.0001 12.4444 21.0001H8C5.79086 21.0001 4 19.2092 4 17.0001V10.6843C4 8.62179 5.56104 6.92387 7.56608 6.70758Z","fill":"#0088BF","key":0}),React.createElement("rect",{"x":"8.55566","y":"4","width":"10.4444","height":"12.3158","rx":"3","stroke":"#0088BF","strokeWidth":"2","key":1})]);
}

Copy.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Copy;

Copy.default = Copy;
